import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { tuiFormatSize, tuiFileOptionsProvider } from '@taiga-ui/kit';
function isFactoryProvider(value) {
  return value instanceof Function;
}
function getProviderKey(value) {
  return isFactoryProvider(value) ? 'useFactory' : 'useValue';
}
function getProviderKeyByType(type) {
  return type === 'value' ? 'useValue' : 'useFactory';
}
function provideFormControl(component) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => component),
    multi: true
  };
}
function provideControlValidator(component) {
  return {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => component),
    multi: true
  };
}
function provideCustomFileOptions() {
  const customFileUnits = ['B', 'KB', 'MB'];
  const CUSTOM_FILE_OPTIONS = {
    formatSize: (units, size) => tuiFormatSize(customFileUnits, size)
  };
  return tuiFileOptionsProvider(CUSTOM_FILE_OPTIONS);
}

/**
 * Generated bundle index. Do not edit.
 */

export { getProviderKey, getProviderKeyByType, isFactoryProvider, provideControlValidator, provideCustomFileOptions, provideFormControl };
